/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDistanceMethod.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/distance-method";

export class AutogenModelDistanceMethod<RowType extends ModelRow> extends Endpoint<RowType, RowDistanceMethodFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDistanceMethod extends ModelRow<RowDistanceMethodFields> {
	constructor(values?: Partial<RowDistanceMethodFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDistanceMethodFields {
	company_id: string;
	descr: string;
	id: string;
	method_id: string;
	source_id: string;
}

